import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_commodity_price_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { name?: string, date_from?: string, date_to?: string, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { price_id?: string, name?: string, description?: string, value?: number, date?: string, date_number?: number }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/Invoices/datasources/ds_commodity_price_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { name?: string, date_from?: string, date_to?: string, full_text_search?: string, $keys: string[] }): Promise<{ result?: { price_id?: string, name?: string, description?: string, value?: number, date?: string, date_number?: number }[] }> {

    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_commodity_price_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
